<template>
  <DialogHeader>
    <template #right>
      <div
        class="font-medium text-green-900 cursor-pointer"
        @click="handleClick"
      >
        Go
      </div>
    </template>
    Can't pay here
  </DialogHeader>
  <DialogContent>
    Please go to Dacr.com to pay your outstanding balance.
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="handleClick">
      Go to Dacr.com
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'

const { close } = useDialog()

const handleClick = () => {
  window.open(import.meta.env.VITE_URL, '_blank')
  close()
}
</script>
